// extracted by mini-css-extract-plugin
export default {"general":"Link_general--JDR","primary":"Link_primary--v18","secondary":"Link_secondary--xjP"};